import React from 'react';
import { useRouter } from 'next/router';

const recreateOnNavigation = Component => {
  const InnerComponent = props => {
    const { name } = props;
    const router = useRouter();
    const key = `${router.asPath}:${name}`;
    return <Component {...props} key={key} />;
  };

  InnerComponent.WrappedComponent = Component;

  InnerComponent.displayName = `recreateOnNavigation(${Component.displayName ||
    Component.name ||
    'Component'})`;

  return InnerComponent;
};

export default recreateOnNavigation;
